export const getResponseStatus = async (response) => {
    if (response.ok) {
      let responseData = await response.json();
      return responseData;
    } else {
      return "error";
    }
  };
  